import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum UnavailabilitySource {
  bookingWindowRule = 'booking_window_rule',
  linkedListing = 'linked_listing',
  linkedUnavailability = 'linked_unavailability',
  partnerApi = 'partner_api',
  linkedPartnerApi = 'linked_partner_api',
  onboarded = 'onboarded',
}

export default class UnavailabilityModel extends Model {
  @attr('string') source!: UnavailabilitySource;
  @attr('string') description!: string;
  @attr('string') from!: string;
  @attr('string') to!: string;
  @attr('date') createdAt!: Date;
  @attr('string') createdByName?: string;

  get checkIn(): string {
    return this.from;
  }

  set checkIn(value: string) {
    this.from = value;
  }

  get checkOut(): string {
    return this.to;
  }

  set checkOut(value: string) {
    this.to = value;
  }

  @cached
  get isFromBookingWindow(): boolean {
    return this.source === UnavailabilitySource.bookingWindowRule;
  }

  @cached
  get isFromLinkedListing(): boolean {
    return this.source === UnavailabilitySource.linkedListing;
  }

  @cached
  get isFromLinkedUnavailability(): boolean {
    return [
      UnavailabilitySource.linkedUnavailability,
      UnavailabilitySource.linkedPartnerApi,
    ].includes(this.source);
  }

  @cached
  get isEditable(): boolean {
    return !(
      this.isFromBookingWindow ||
      this.isFromLinkedListing ||
      this.isFromLinkedUnavailability
    );
  }

  @belongsTo('booking', {
    inverse: null,
    async: false,
  })
  booking!: ModelRegistry['booking'];

  @belongsTo('calendar', {
    inverse: 'unavailabilities',
    async: false,
  })
  calendar!: ModelRegistry['calendar'];

  @belongsTo('property', {
    inverse: 'unavailabilities',
    async: false,
  })
  property!: ModelRegistry['property'];

  @belongsTo('multi-unit', {
    inverse: 'unavailabilities',
    async: false,
  })
  multiUnit!: ModelRegistry['multi-unit'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    unavailability: UnavailabilityModel;
  }
}
